// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__btqtU","main":"Layout_main__MZa8Y","body":"Layout_body__I-Shz"};